// LinkedIn standard industry taxonomy (most commonly used subset, ~120 industries)
export const LINKEDIN_INDUSTRIES = [
  "Accounting",
  "Advertising Services",
  "Aerospace and Aviation",
  "Agriculture",
  "Airlines and Aviation",
  "Alternative Medicine",
  "Animation and Post-production",
  "Apparel & Fashion",
  "Architecture & Planning",
  "Arts and Crafts",
  "Automotive",
  "Aviation & Aerospace",
  "Banking",
  "Beverage Manufacturing",
  "Biotechnology Research",
  "Broadcast Media Production and Distribution",
  "Building Materials",
  "Business Consulting and Services",
  "Business Supplies & Equipment",
  "Capital Markets",
  "Chemical Manufacturing",
  "Civic and Social Organizations",
  "Civil Engineering",
  "Commercial Real Estate",
  "Computer & Network Security",
  "Computer Games",
  "Computer Hardware Manufacturing",
  "Computer Networking Products",
  "Construction",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Services",
  "Cosmetics",
  "Dairy Product Manufacturing",
  "Defense and Space Manufacturing",
  "Design Services",
  "E-Learning Providers",
  "Education Administration Programs",
  "Education Management",
  "Electrical/Electronic Manufacturing",
  "Entertainment Providers",
  "Environmental Services",
  "Events Services",
  "Executive Offices",
  "Facilities Services",
  "Farming",
  "Financial Services",
  "Fine Art",
  "Fishery",
  "Food & Beverages",
  "Food Production",
  "Fund-Raising",
  "Furniture",
  "Gambling Facilities and Casinos",
  "Glass, Ceramics & Concrete Manufacturing",
  "Government Administration",
  "Government Relations Services",
  "Graphic Design",
  "Health, Wellness & Fitness",
  "Higher Education",
  "Hospitality",
  "Hospitals and Health Care",
  "Human Resources Services",
  "Import and Export",
  "Individual and Family Services",
  "Industrial Automation",
  "Industrial Machinery Manufacturing",
  "Information Services",
  "Information Technology & Services",
  "Insurance",
  "International Affairs",
  "International Trade and Development",
  "Internet Marketplace Platforms",
  "Internet Publishing",
  "Investment Banking",
  "Investment Management",
  "IT Services and IT Consulting",
  "Judiciary",
  "Law Enforcement",
  "Law Practice",
  "Legal Services",
  "Legislative Offices",
  "Leisure, Travel & Tourism",
  "Libraries",
  "Logistics and Supply Chain",
  "Luxury Goods & Jewelry",
  "Machinery Manufacturing",
  "Management Consulting",
  "Maritime Transportation",
  "Marketing Services",
  "Market Research",
  "Mechanical or Industrial Engineering",
  "Media Production",
  "Medical Device Manufacturing",
  "Medical Practices",
  "Mental Health Care",
  "Military and International Affairs",
  "Mining",
  "Motion Pictures and Film",
  "Motor Vehicle Manufacturing",
  "Museums and Institutions",
  "Music",
  "Nanotechnology Research",
  "Newspaper Publishing",
  "Non-profit Organization Management",
  "Nuclear Electric Power Generation",
  "Oil and Gas",
  "Online Audio and Video Media",
  "Outsourcing/Offshoring",
  "Package/Freight Delivery",
  "Packaging and Containers Manufacturing",
  "Paper & Forest Products",
  "Performing Arts",
  "Personal Care Product Manufacturing",
  "Pharmaceutical Manufacturing",
  "Philanthropic Fundraising Services",
  "Photography",
  "Plastics Manufacturing",
  "Political Organizations",
  "Primary and Secondary Education",
  "Printing Services",
  "Professional Training and Coaching",
  "Public Policy Offices",
  "Public Relations and Communications Services",
  "Public Safety",
  "Publishing",
  "Railroad Equipment Manufacturing",
  "Ranching",
  "Real Estate",
  "Recreational Facilities",
  "Religious Institutions",
  "Renewable Energy Semiconductor Manufacturing",
  "Research Services",
  "Restaurants",
  "Retail",
  "Retail Apparel and Fashion",
  "Retail Groceries",
  "Retail Luxury Goods and Jewelry",
  "Retail Office Equipment",
  "Security and Investigations",
  "Semiconductor Manufacturing",
  "Services for Renewable Energy",
  "Shipbuilding",
  "Software Development",
  "Spectator Sports",
  "Sporting Goods Manufacturing",
  "Sports",
  "Staffing and Recruiting",
  "Strategic Management Services",
  "Supermarkets",
  "Technology, Information and Internet",
  "Telecommunications",
  "Textile Manufacturing",
  "Think Tanks",
  "Tobacco Manufacturing",
  "Translation and Localization",
  "Transportation, Logistics, Supply Chain and Storage",
  "Travel Arrangements",
  "Truck Transportation",
  "Utilities",
  "Venture Capital and Private Equity Principals",
  "Veterinary Services",
  "Warehousing and Storage",
  "Wellness and Fitness Services",
  "Wholesale",
  "Wholesale Building Materials",
  "Wholesale Import and Export",
  "Wine and Spirits",
  "Wireless Services",
  "Writing and Editing",
];
